export const AppRoutes = {
  Home: "/",
  Users: "/users",
  SingleUser: ":id",

  Post: "/posts",
  Todos: "/todos",

  Error: "*",
};
